import { Modal, SubmitButton, Table } from "@xola/ui-kit";
import React, { useState } from "react";
import { Except } from "type-fest";
import { PartnerDemographicPrice, Product } from "types";
import { NoTranslate } from "../../Common/NoTranslate";
import { ProductImage } from "../../Common/ProductImage";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { XolaFormik } from "../../Common/XolaFormik";
import { DemographicPriceItem } from "./DemographicPriceItem";

interface EditDemographicTermModalProps {
    isOpen: boolean;
    partnerDemographicPrices: PartnerDemographicPrice[];
    product: Product;
    onSubmit: (partnerDemographicPrices: PartnerDemographicPrice[]) => void;
    onClose: () => void;
}

export const EditDemographicTermModal = ({
    isOpen,
    partnerDemographicPrices,
    product,
    onSubmit,
    onClose,
}: EditDemographicTermModalProps) => {
    return (
        <Modal size="huge" isOpen={isOpen} onClose={onClose} onSubmit={onsubmit}>
            <ModalContent
                partnerDemographicPrices={partnerDemographicPrices}
                product={product}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </Modal>
    );
};

const ModalContent = ({
    partnerDemographicPrices,
    product,
    onClose,
    onSubmit,
}: Except<EditDemographicTermModalProps, "isOpen">) => {
    const [demographicPricesValues, setDemographicPricesValues] =
        useState<PartnerDemographicPrice[]>(partnerDemographicPrices);

    return (
        <XolaFormik enableReinitialize initialValues={demographicPricesValues} onSubmit={onSubmit}>
            {({ handleSubmit, values, setFieldValue }) => {
                const handleDelete = (removeIndex: number) => {
                    setDemographicPricesValues(values?.filter((value, index) => removeIndex !== index));
                };

                return (
                    <>
                        <Modal.Header>Edit Purchasable Unit Terms</Modal.Header>

                        <Modal.Body>
                            <div className="space-y-2">
                                <div className="flex items-center">
                                    <ProductImage
                                        product={{
                                            id: product.id,
                                            name: product?.name,
                                            object: product?.object,
                                        }}
                                        size="small"
                                    />
                                    <NoTranslate className="w-full text-sm font-bold">{product?.name}</NoTranslate>
                                </div>

                                <Table>
                                    <Table.Head>
                                        <Table.Row>
                                            <Table.Header>Name</Table.Header>
                                            <Table.Header>Adjustment</Table.Header>
                                            <Table.Header>Commission</Table.Header>
                                            <Table.Header />
                                        </Table.Row>
                                    </Table.Head>

                                    <Table.Body>
                                        {values.map((agentDemographicPrice: PartnerDemographicPrice, index: number) => {
                                            return (
                                                <DemographicPriceItem
                                                    key={agentDemographicPrice.template.id}
                                                    index={index}
                                                    agentDemographicPrice={agentDemographicPrice}
                                                    setFieldValue={setFieldValue}
                                                    handleDelete={() => handleDelete(index)}
                                                />
                                            );
                                        })}
                                    </Table.Body>
                                </Table>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                            <SubmitButton type="submit" onClick={handleSubmit}>
                                Save
                            </SubmitButton>
                        </Modal.Footer>
                    </>
                );
            }}
        </XolaFormik>
    );
};
